import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import SupportTypeComponentLegacy from "../../../components/applicationComponents/legacy/supportType/SupportTypeLegacy";

export default function SupportTypePageLegacy() {
  const [id, setId] = useState("");
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const idParam = searchParams.get("id");
    setId(idParam ?? "");
  }, []);

  return (
    <>
      <SupportTypeComponentLegacy disabled={false} id={id} />
    </>
  );
}
